export default __webpack_public_path__ + "static/media/loginPattern.690c379e.svg";